export const primary = "#B00026";
export const secondary = "#008150";
